import { model, models, Schema, Types } from "mongoose";
import { IMods } from "./types";

const ModsSchema = new Schema<IMods>(
  {
    chainId: { type: Number, required: true },
    account: { type: String, required: true },
    role: {
      type: String,
      enum: ["admin", "mods"],
      required: true,
    },
    isAllowed: {
      type: Boolean,
      default: true,
    },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;
      },
    },
  }
);

ModsSchema.index({ chainId: 1, account: 1 }, { unique: true });

export const ModsModel = models?.Mods || model<IMods>("Mods", ModsSchema);
